import { messagesEn } from "./messagesEn.constants";
import { messagesVi } from "./messagesVi.constants";

export const allLanguages = {
  en: messagesEn,
  vi: messagesVi,
};